import { useTranslation } from 'react-i18next';
import { reportCreatorI18n } from '../i18n';

const BuilderZone = ({
  DesignSystemComponents,
  id,
  title,
  helpText,
  items,
  error,
  onDropField,
  onSelectChip,
  selectedChip,
  onRemoveChip,
  onDragZoneChipStart,
  onDropZoneChip,
  onMoveChip,
}) => {
  const { IconButton } = DesignSystemComponents ?? {};
  const { t } = useTranslation(undefined, { i18n: reportCreatorI18n });

  return (
    <section
      className={`builder-zone ${error ? 'has-error' : ''}`}
      onDragOver={(event) => event.preventDefault()}
      onDrop={(event) => onDropField(event, id)}
      aria-label={t('rc_zone_aria', { title })}
    >
      <div className='builder-zone-header'>
        <h4 className='mb-1'>{title}</h4>
        <p className='caption color-gray-600 mb-0'>{helpText}</p>
      </div>

      {items.length === 0 ? (
        <div className='builder-zone-empty caption'>{t('rc_zone_drop_here')}</div>
      ) : (
        <div className='builder-zone-list'>
          {items.map((item, index) => {
            const isSelected =
              selectedChip?.zone === id && selectedChip?.uiId === item.uiId;
            return (
              <div
                key={item.uiId}
                className={`builder-zone-chip ${isSelected ? 'is-selected' : ''}`}
                draggable
                aria-label={t('rc_chip_aria', { label: item.label })}
                onDragStart={(event) => onDragZoneChipStart(event, id, index)}
                onDragOver={(event) => event.preventDefault()}
                onDrop={(event) => onDropZoneChip(event, id, index)}
              >
                <button
                  type='button'
                  className='builder-chip-main'
                  onClick={() => onSelectChip({ zone: id, uiId: item.uiId })}
                >
                  <span className='builder-chip-label'>{item.label}</span>
                  {item.aggregation && (
                    <span className='builder-chip-meta'>
                      {item.aggregation}
                    </span>
                  )}
                  {item.operator && (
                    <span className='builder-chip-meta'>{item.operator}</span>
                  )}
                  {item.direction && (
                    <span className='builder-chip-meta'>{item.direction}</span>
                  )}
                </button>
                <div className='builder-chip-actions'>
                  <button
                    type='button'
                    aria-label={t('rc_chip_move_up')}
                    className='builder-chip-action-btn'
                    onClick={() => onMoveChip(id, index, index - 1)}
                    disabled={index === 0}
                  >
                    ↑
                  </button>
                  <button
                    type='button'
                    aria-label={t('rc_chip_move_down')}
                    className='builder-chip-action-btn'
                    onClick={() => onMoveChip(id, index, index + 1)}
                    disabled={index === items.length - 1}
                  >
                    ↓
                  </button>
                  {IconButton ? (
                    <IconButton
                      ariaLabel={t('rc_chip_remove')}
                      icon='trash'
                      onClick={() => onRemoveChip(id, item.uiId)}
                    />
                  ) : (
                    <button
                      type='button'
                      className='builder-chip-action-btn'
                      onClick={() => onRemoveChip(id, item.uiId)}
                    >
                      ✕
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {error && <p className='builder-zone-error mb-0'>{error}</p>}
    </section>
  );
};

export default BuilderZone;
